<template>
  <div class="main-panel">
    <div class="content-wrapper dashboard-shell">
      <div class="row justify-content-center">
        <div class="col-12 col-xl-10 grid-margin">
          <div class="card cardplay user-shell">
            <div class="card-body user-card-body">
              <form-tag @userEditEvent="submitHandler" name="userform" event="userEditEvent">
                <div class="row dashboard-header g-3 align-items-center mb-4">
                  <div class="col-12 col-lg-8">
                    <h4 class="dashboard-title mb-2" v-if="this.user.id === 0">Gestionar Usuario</h4>
                    <h4 class="dashboard-title mb-2" v-else>Editar Usuario</h4>
                    <p class="user-subtitle mb-0">
                      Complete la información del usuario, seleccione sus roles y sucursales, y guarde los cambios.
                    </p>
                  </div>
                  <div class="col-12 col-lg-4 d-flex justify-content-lg-end align-items-center">
                    <span class="user-badge">{{ this.user.id === 0 ? 'Nuevo usuario' : 'Edición activa' }}</span>
                  </div>
                </div>

                <div class="accordion user-accordion" id="userEditAccordion">
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingUserData">
                      <button class="accordion-button" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapseUserData" aria-expanded="true" aria-controls="collapseUserData">
                        Datos del Usuario
                      </button>
                    </h2>
                    <div id="collapseUserData" class="accordion-collapse collapse show" aria-labelledby="headingUserData">
                      <div class="accordion-body">
                        <div class="row g-3">
                          <div class="col-12 col-md-6">
                            <label for="first-name" class="form-label">Nombre</label>
                            <text-input v-model="user.first_name" type="text" :required="true" label="First Name"
                              :value="user.first_name" name="first-name">
                            </text-input>
                          </div>

                          <div class="col-12 col-md-6">
                            <label for="last-name" class="form-label">Apellido</label>
                            <text-input v-model="user.last_name" type="text" :required="true" label="Last Name"
                              :value="user.last_name" name="last-name">
                            </text-input>
                          </div>

                          <div class="col-12 col-md-6">
                            <label for="email" class="form-label">Correo Electronico</label>
                            <text-input v-model="user.email" type="email" :required="true" label="Email" autocomplete="off" :value="user.email"
                              name="email">
                            </text-input>
                          </div>

                          <div class="col-12 col-md-6">
                            <label for="password" class="form-label">Contraseña</label>
                            <text-input v-if="this.user.id === 0" v-model="user.password" type="password" :required="true"
                              label="Password" autocomplete="new-password" :value="user.password" name="password">
                            </text-input>

                            <text-input v-else v-model="user.password" type="password" label="Password"
                              help="Leave empty to keep existing password" autocomplete="new-password" :value="user.password" name="password">
                            </text-input>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingRoles">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapseRoles" aria-expanded="false" aria-controls="collapseRoles">
                        Roles
                      </button>
                    </h2>
                    <div id="collapseRoles" class="accordion-collapse collapse" aria-labelledby="headingRoles">
                      <div class="accordion-body section-content-padding">
                        <div class="row ms-1 g-2">
                          <div class="col-sm-6 col-12">
                            <div class="form-check">
                              <input class="form-check-input" type="checkbox" value="Admin" id="rolAdmin" v-model="this.user.roles" />
                              <label class="form-check-label" for="rolAdmin">Admin</label>
                            </div>
                            <div class="form-check">
                              <input class="form-check-input" type="checkbox" value="Coordinacion" id="rolCoordinacion"
                                v-model="this.user.roles" />
                              <label class="form-check-label" for="rolCoordinacion">Coordinacion</label>
                            </div>
                            <div class="form-check">
                              <input class="form-check-input" type="checkbox" value="Coordinador Sucursal"
                                id="rolCoordinadorSucursal" v-model="this.user.roles" />
                              <label class="form-check-label" for="rolCoordinadorSucursal">Coordinador Sucursal</label>
                            </div>
                            <div class="form-check">
                              <input class="form-check-input" type="checkbox" value="Jefa Financiamiento" id="rolJefaFin"
                                v-model="this.user.roles" />
                              <label class="form-check-label" for="rolJefaFin">Jefa Financiamiento</label>
                            </div>
                            <div class="form-check">
                              <input class="form-check-input" type="checkbox" value="Modo Thanos" id="rolThanos"
                                v-model="this.user.roles" />
                              <label class="form-check-label" for="rolThanos">Modo Thanos</label>
                            </div>
                            <div class="form-check">
                              <input class="form-check-input" type="checkbox" value="Legal" id="rolLegal" v-model="this.user.roles" />
                              <label class="form-check-label" for="rolLegal">Legal</label>
                            </div>
                          </div>
                          <div class="col-sm-6 col-12">
                            <div class="form-check">
                              <input class="form-check-input" type="checkbox" value="Finanzas" id="rolFinanzas"
                                v-model="this.user.roles" />
                              <label class="form-check-label" for="rolFinanzas">Finanzas</label>
                            </div>
                            <div class="form-check">
                              <input class="form-check-input" type="checkbox" value="Talento Humano" id="rolTH"
                                v-model="this.user.roles" />
                              <label class="form-check-label" for="rolTH">Talento Humano</label>
                            </div>
                            <div class="form-check">
                              <input class="form-check-input" type="checkbox" value="Asesor" id="rolAsesor"
                                v-model="this.user.roles" />
                              <label class="form-check-label" for="rolAsesor">Asesor</label>
                            </div>
                            <div class="form-check">
                              <input class="form-check-input" type="checkbox" value="Consultor" id="rolConsultor"
                                v-model="this.user.roles" />
                              <label class="form-check-label" for="rolConsultor">Consultor</label>
                            </div>
                            <div class="form-check">
                              <input class="form-check-input" type="checkbox" value="Gestor Archivos" id="rolGestor"
                                v-model="this.user.roles" />
                              <label class="form-check-label" for="rolGestor">Gestor Archivos</label>
                            </div>
                            <div class="form-check">
                              <input class="form-check-input" type="checkbox" value="Oficina General" id="rolOficina"
                                v-model="this.user.roles" />
                              <label class="form-check-label" for="rolOficina">Oficina General</label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingSucursales">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapseSucursales" aria-expanded="false" aria-controls="collapseSucursales">
                        Sucursal
                      </button>
                    </h2>
                    <div id="collapseSucursales" class="accordion-collapse collapse" aria-labelledby="headingSucursales">
                      <div class="accordion-body section-content-padding">
                        <div class="row ms-1 g-2">
                          <div class="col-12">
                            <div class="form-check">
                              <input class="form-check-input" type="checkbox" value="ALL" id="flexCheckALL" v-model="this.sucursal">
                              <label class="form-check-label" for="flexCheckALL">ALL</label>
                            </div>
                          </div>
                          <div v-for="sucursalItem in sucursalesDisponibles" :key="sucursalItem.id" class="col-sm-6 col-12">
                            <div class="form-check">
                              <input
                                class="form-check-input"
                                type="checkbox"
                                :value="sucursalItem.nombre"
                                :id="`sucursal-${sucursalItem.id}`"
                                v-model="sucursal"
                              >
                              <label class="form-check-label" :for="`sucursal-${sucursalItem.id}`">
                                {{ sucursalItem.nombre }}
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="accordion-item">
                    <h2 class="accordion-header" id="headingEstado">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapseEstado" aria-expanded="false" aria-controls="collapseEstado">
                        Estado del Usuario
                      </button>
                    </h2>
                    <div id="collapseEstado" class="accordion-collapse collapse" aria-labelledby="headingEstado">
                      <div class="accordion-body section-content-padding">
                        <div class="row ms-1 g-2">
                          <div class="col-sm-6 col-12">
                            <div class="form-check">
                              <input v-model="user.active" type="radio" class="form-check-input" id="user-active" :value="1">
                              <label for="user-active" class="form-check-label">Active</label>
                            </div>
                            <div class="form-check">
                              <input v-model="user.active" type="radio" class="form-check-input" id="user-inactive" :value="0">
                              <label for="user-inactive" class="form-check-label">Inactive</label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="action-row mt-4">
                  <div class="d-flex gap-2 flex-wrap">
                    <input type="submit" class="btn btn-primary user-main-btn" value="Save" />
                    <router-link to="/axccAdminSettings" class="btn btn-outline-secondary user-cancel-btn">Cancel</router-link>
                  </div>
                  <a v-if="this.$route.params.userId > 0 &&
                    parseInt(String(this.$route.params.userId), 10) !== store.user.id"
                    class="btn btn-danger user-delete-btn" href="javascript:void(0);" @click="condirmDelete(this.user.id)">
                    Delete
                  </a>
                </div>
              </form-tag>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Security from "../security";
import FormTag from "../forms/Form-Tag.vue";
import TextInput from "../forms/Text-Input.vue";
import notie from "notie";
import { store } from "../store";
import router from '../../router/index.js'
import direccionData from '../solicitud/direccionData.json';

export default {
  beforeMount() {
    Security.requireToken();
    this.departamentos = [...direccionData[0].departamentos, { idDepartamento: 0, nombre: "ALL" }];
    this.fetchSucursales();
    this.loadUserFromRoute();
  },
  data() {
    return {
      departamentos: [],
      sucursalesDisponibles: [],
      departamentoSeleccionado: null,
      admin: false,
      coordinacion: false,
      finanzas: false,
      talentoHumano: false,
      user: {
        id: 0,
        first_name: "",
        last_name: "",
        email: "",
        password: "",
        active: 0,
        sucursal: [],
        roles: [],
      },
      sucursal: [],
      store,
    };
  },
  components: {
    "form-tag": FormTag,
    "text-input": TextInput,
  },
  watch: {
    '$route.params.userId': function () {
      this.loadUserFromRoute();
    },
    'sucursal': function (val) {
      this.user.sucursal = val
      console.log(this.user.sucursal)
    },
    'user.roles': function (val) {
      console.log(val)
    }
  },
  methods: {
    getDefaultUser() {
      return {
        id: 0,
        first_name: "",
        last_name: "",
        email: "",
        password: "",
        active: 0,
        sucursal: [],
        roles: [],
      };
    },
    resetNewUserState() {
      this.user = this.getDefaultUser();
      this.sucursal = [];
    },
    fetchSucursales() {
      fetch(process.env.VUE_APP_API_URL + "/admin/sucursales/all", Security.requestOptions({}))
        .then((response) => response.json())
        .then((response) => {
          if (response.error) {
            this.$emit('error', response.message);
            return;
          }

          this.sucursalesDisponibles = response.data?.sucursales || [];
        })
        .catch((error) => {
          this.$emit('error', error);
        });
    },
    loadUserFromRoute() {
      const userId = parseInt(String(this.$route.params.userId), 10);
      if (userId > 0) {
        fetch(process.env.VUE_APP_API_URL + "/admin/users/get/" + userId, Security.requestOptions(""))
          .then((response) => response.json())
          .then((data) => {
            if (data.error) {
              this.$emit('error', data.message);
            } else {
              this.user = data;
              console.log(data)
              this.sucursal = data.sucursal || [];
              this.user.password = "";
            }
          })
      } else {
        this.resetNewUserState();
      }
    },
    submitHandler() {
      const payload = {
        id: parseInt(String(this.$route.params.userId), 10),
        first_name: this.user.first_name,
        last_name: this.user.last_name,
        email: this.user.email,
        password: this.user.password,
        active: this.user.active,
        roles: this.user.roles,
        sucursal: this.sucursal
      };
      console.log(payload)
      fetch(
        `${process.env.VUE_APP_API_URL}/admin/users/save`,
        Security.requestOptions(payload)
      )
        .then((response) => response.json())
        .then((data) => {
          if (data.error) {
            this.$emit('error', data.message);
          } else {
            this.$emit('success', "Changes saved!");
            router.push("/axccAdminSettings");
          }
        })
        .catch((error) => {
          this.$emit('error', error);
        });
    },
    condirmDelete(id) {
      notie.confirm({
        text: "Are you suer you want to delete this user?",
        submitText: "Delete",
        submitCallback: function () {
          console.log("Will delete", id);

          let payload = {
            id: id,
          }

          fetch(process.env.VUE_APP_API_URL + "/admin/users/delete", Security.requestOptions(payload))
            .then((response) => response.json())
            .then((data) => {
              if (data.error) {
                notie.alert({
                  type: "error",
                  text: data.message,
                })
              } else {
                notie.alert({
                  type: "success",
                  text: "User deleted"
                })
                router.push("/axccAdminSettings")
              }
            })
        }
      })
    },
  },
};
</script>

<style scoped>
.dashboard-shell {
  background: linear-gradient(165deg, #f5f7fb 0%, #eef1f7 45%, #f8fafc 100%);
  min-height: 100vh;
}

.cardplay {
  border-radius: 24px;
  border: 1px solid #e5e7eb;
  padding: 24px;
  background-color: #ffffff;
  box-shadow: 0 24px 60px rgba(15, 23, 42, 0.08);
}

.user-card-body {
  padding: 0;
}

.dashboard-header {
  background: linear-gradient(120deg, #111827 0%, #1f2937 70%, #374151 100%);
  border-radius: 18px;
  color: #fff;
  padding: 14px 16px;
}

.dashboard-title {
  color: #fff;
  font-weight: 700;
  letter-spacing: 0.4px;
  font-size: 1.35rem;
}

.user-subtitle {
  color: #e5e7eb;
  font-size: 0.95rem;
}

.user-badge {
  display: inline-block;
  border: 1px solid #e5e7eb66;
  border-radius: 999px;
  padding: 0.3rem 0.75rem;
  color: #f9fafb;
  font-size: 0.85rem;
}

.user-main-btn {
  border-radius: 999px;
  font-weight: 600;
}

.user-cancel-btn,
.user-delete-btn {
  border-radius: 999px;
  font-weight: 600;
}

.user-accordion {
  border-radius: 18px !important;
}

.user-accordion .accordion-item {
  border: 1px solid #e2e8f0 !important;
  border-radius: 14px !important;
  overflow: hidden !important;
  margin-bottom: 12px !important;
  box-shadow: 0 8px 22px rgba(15, 23, 42, 0.06) !important;
}

.user-accordion .accordion-header {
  border-radius: 14px !important;
}

.user-accordion .accordion-button {
  background: linear-gradient(120deg, #f8fafc 0%, #eef2ff 100%) !important;
  color: #111827 !important;
  font-weight: 700 !important;
  border: none !important;
  box-shadow: none !important;
  padding: 0.9rem 1rem !important;
}

.user-accordion .accordion-button:not(.collapsed) {
  background: linear-gradient(120deg, #111827 0%, #1f2937 100%) !important;
  color: #f9fafb !important;
}

.user-accordion .accordion-button::after {
  filter: grayscale(0.2) contrast(1.2) !important;
}

.user-accordion .accordion-button:not(.collapsed)::after {
  filter: brightness(2.5) !important;
}

.user-accordion .accordion-body {
  background: #ffffff !important;
  padding: 1rem !important;
}

.action-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
}

.form-label {
  font-weight: 600;
  color: #374151;
}


.section-content-padding {
  padding-left: 0.5rem !important;
}
.form-check-label {
  color: #1f2937;
}

.form-check-input {
  margin-left: 0.35rem !important;
}
</style>
